import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';

const StyledButton = styled(Button)(({ customstyle }) => ({
  ...customstyle,
}));

const StyledLink = styled(Link)(({ customstyle }) => ({
  ...customstyle,
}));

export { StyledButton, StyledLink };
